// Redux Store配置
import { configureStore } from '@reduxjs/toolkit';
import accountReducer from '../data/accountSlice';
import statusReducer from '../data/statusSlice';
import languageReducer from '../data/languageSlice';

export const store = configureStore({
  reducer: {
    account: accountReducer,
    status: statusReducer,
    language: languageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
